import { render } from "./IntRule.vue?vue&type=template&id=1608899c"
import script from "./IntRule.vue?vue&type=script&lang=js"
export * from "./IntRule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__